import utagLinkGeneric from './utagLinkGeneric';

function utagLinkStoreAvailability (eventCategory = 'Check-Store') {

	return ({ eventAction, eventLabel = '', nonInteraction = 0 }) => {

		utagLinkGeneric({
			eventCategory,
			eventAction,
			eventLabel,
			nonInteraction
		});

	};

}

export default utagLinkStoreAvailability;
